import instance from '../utils/instance';

class FieldDescriptionService {

    async getGridDescription(deMetaId) {
        return instance.get(`/field/description/grid?deMetaId=${deMetaId}`);
    }

    async getListDescription(deMetaId) {
        return instance.get(`/field/description/list?deMetaId=${deMetaId}`);
    }
}

export default new FieldDescriptionService();